import classNames from 'classnames';
import get from 'lodash/get';

export const setTheme = (className, document, styles) =>
  classNames(
    className,
    styles[get(document, 'fields.textColor', undefined)],
    styles[get(document, 'fields.className', undefined)],
  );
